function PageScrollController(){
    this.glob = "/**";
    this.log = false;
};
PageScrollController.inheritsFrom( StandardController );
PageScrollController.prototype.on = function(){
    this.$body = $("body");

    this.showLogoFirstTime = true;
    this.logoAnimationDuration = 300;

    // console.log('%c[PageScrollController]', 'color:orange')
    
    // The smooth scroll effect relies on the GSAP library (scripts loaded in the footer)
    // <script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.5.1/gsap.min.js"></script>
    // <script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.5.1/ScrollTrigger.min.js"></script>
    
    /*
    this.$container = this.$body.find(".page-scroll-scrollable");
    if(!this.$container.length) return;

    console.log(this.$container);
    
    const setHeight = () => {
        this.height = this.$container[0].clientHeight;
        this.$body.css({height: `${this.height}px`});
    }

    gsap.registerPlugin(ScrollTrigger);
    
    // ScrollTrigger.addEventListener("refreshInit", setHeight);
    // ScrollTrigger.addEventListener("scrollEnd", setHeight);

    // // smooth scrolling container
    // gsap.to(this.container, {
    //     y: () => -(this.height - document.documentElement.clientHeight),
    //     ease: "none",
    //     scrollTrigger: {
    //         trigger: document.body,
    //         start: "top top",
    //         end: "bottom bottom",
    //         scrub: 1,
    //         invalidateOnRefresh: true,
    //     }
    // });

    */
    
    window.onscroll = this.setPageLogoPosition;
    window.onresize = this.setPageLogoPosition;
    this.setPageLogoPosition();

};
PageScrollController.prototype.off = function(){
    
};

PageScrollController.prototype.setPageLogoPosition = function() {

    if (this.log) console.log(`%c[PageSCrollController]`, 'background:darksalmon', `setPageLogoPosition`);

    const isHome = document.querySelector('.body-home');

    // Identify logo and its parts.
    let logo;
    if (isHome) {
        logo = document.querySelector('.intro .page-logo');
    } else {
        logo = document.querySelector('.page-logo');
    }
    
    const logoTop = logo.querySelector('.logo-top');
    const logoBottom = logo.querySelector('.logo-bottom');
    
    let fixedPositionY = 30;
    let triggerPositionY = 30;
    
    const isDesktop = $(window).innerWidth() >= 1000;
    if(isDesktop) {
        fixedPositionY = 100;
        triggerPositionY = $(window).innerHeight()/2 - fixedPositionY;
    }

    let triggerHidePositionY = $(window).innerHeight()/10;
    if (isHome) {
        triggerHidePositionY = triggerPositionY;
    }
    
    const scrollPositionY = $(window).scrollTop();
    const isLogoFixed = scrollPositionY > triggerPositionY;    

    const shouldHideLogo = scrollPositionY > triggerHidePositionY;
    if (shouldHideLogo) {
        let timeToRemove = 0;
        if (!this.showLogoFirstTime) {
            timeToRemove = this.logoAnimationDuration;
        }
        $(logoBottom).fadeOut(timeToRemove);
        this.showLogoFirstTime = false;
    } else {
        $(logoBottom).fadeIn(this.logoAnimationDuration);
    }
    this.showLogoFirstTime = false;

    // console.log(scrollPositionY, triggerPositionY);

    // Pin the logo when it reaches the top position after scrolling
    if (isLogoFixed) {

        // Set logo fixed position.
        logo.style.top = isDesktop ? `${fixedPositionY - 61}px` : `${fixedPositionY}px`;
        return;

    }

    // Calculate dynamic position for moving logo in the homepage.
    if (isHome) {
        
        // Set logo custom position.
        logo.style.top = isDesktop ? `calc(50% - ${scrollPositionY + 65}px)` : `30px`;
    
    } else {

        logo.style.top = isDesktop ? `39px` : `30px`;

    }

}